<template>
  <div class="d-flex align-center" style="position: relative">
    <!-- 가상의 파일 -->
    <div v-if="item.fileType_addMethod === 'temp_file'" class="d-flex align-center">
      <!-- Excel -->
      <img v-if="item.fileType_tempFileCategory === 'Excel'"
        src="/assets/data_icon/icon_excel.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- PPT -->
      <img v-else-if="item.fileType_tempFileCategory === 'PPT'"
        src="/assets/data_icon/icon_ppt.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- PDF -->
      <img v-else-if="item.fileType_tempFileCategory === 'PDF'"
        src="/assets/data_icon/icon_pdf2.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- Word -->
      <img v-else-if="item.fileType_tempFileCategory === 'Word'"
        src="/assets/data_icon/icon_word.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- HWP -->
      <img v-else-if="item.fileType_tempFileCategory === 'HWP'"
        src="/assets/data_icon/icon_hwp.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- DB -->
      <img v-else-if="item.fileType_tempFileCategory === 'DB'"
        src="/assets/data_icon/icon_db.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- Re:Data -->
      <img v-else-if="item.fileType_tempFileCategory === 'Re:Data'"
        src="/assets/data_icon/icon_recolumn2.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- Insight -->
      <img v-else-if="item.fileType_tempFileCategory === 'Insight'"
        src="/assets/data_icon/icon_insight.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- Workflow -->
      <img v-else-if="item.fileType_tempFileCategory === 'Workflow'"
        src="/assets/data_icon/icon_rpa2.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
      <!-- Image -->
      <img v-else-if="item.fileType_tempFileCategory === 'Image'"
        src="/assets/data_icon/icon_img.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
    </div>
    <!-- 리컬럼에서 불러오기 - 현재 사용 x (구 버전 데이터에서 사용) -->
    <div v-if="item.fileType_addMethod === 'mtd_file'">
      <!-- file 존재 -->
      <div v-if="item.fileType_selectedFile.file" class="d-flex align-center">
        <!-- Excel -->
        <img v-if="item.fileType_selectedFile.file.includes('xls') || item.fileType_selectedFile.file.includes('csv')"
          src="/assets/data_icon/icon_excel.svg"
          :style="{width: iconWidth, height: iconHeight}"
        >
        <!-- Image -->
        <img v-else-if="item.fileType_selectedFile.file.includes('jpg') || item.fileType_selectedFile.file.includes('jpeg') || item.fileType_selectedFile.file.includes('png')"
          src="/assets/data_icon/icon_img.svg"
          :style="{width: iconWidth, height: iconHeight}"
        >
        <!-- PDF -->
        <img v-else-if="item.fileType_selectedFile.file.includes('pdf')"
          src="/assets/data_icon/icon_pdf2.svg"
          :style="{width: iconWidth, height: iconHeight}"
        >
        <!-- PPT -->
        <img v-else-if="item.fileType_selectedFile.file.includes('ppt')"
          src="/assets/data_icon/icon_ppt.svg"
          :style="{width: iconWidth, height: iconHeight}"
        >
        <!-- JSON -->
        <img v-else-if="item.fileType_selectedFile.file.includes('json')"
          src="/assets/data_icon/icon_json2.svg"
          :style="{width: iconWidth, height: iconHeight}"
        >
        <!-- unknown -->
        <img v-else
          src="/assets/data_icon/icon_unknown.svg"
          :style="{width: iconWidth, height: iconHeight}"
        >
      </div>
      <!-- category 별 분류 -->
      <div v-else-if="item.fileType_selectedFile.category" class="d-flex align-center">
        <!-- file -->
        <div v-if="item.fileType_selectedFile.category === 'file' && item.fileType_selectedFile.file" class="d-flex align-center">
          <!-- Excel -->
          <img v-if="item.fileType_selectedFile.file.includes('xls') || item.fileType_selectedFile.file.includes('csv')"
            src="/assets/data_icon/icon_excel.svg"
            :style="{width: iconWidth, height: iconHeight}"
          >
          <!-- Image -->
          <img v-else-if="item.fileType_selectedFile.file.includes('jpg') || item.fileType_selectedFile.file.includes('jpeg') || item.fileType_selectedFile.file.includes('png')"
            src="/assets/data_icon/icon_img.svg"
            :style="{width: iconWidth, height: iconHeight}"
          >
          <!-- PDF -->
          <img v-else-if="item.fileType_selectedFile.file.includes('pdf')"
            src="/assets/data_icon/icon_pdf2.svg"
            :style="{width: iconWidth, height: iconHeight}"
          >
          <!-- PPT -->
          <img v-else-if="item.fileType_selectedFile.file.includes('ppt')"
            src="/assets/data_icon/icon_ppt.svg"
            :style="{width: iconWidth, height: iconHeight}"
          >
          <!-- JSON -->
          <img v-else-if="item.fileType_selectedFile.file.includes('json')"
            src="/assets/data_icon/icon_json2.svg"
            :style="{width: iconWidth, height: iconHeight}"
          >
          <!-- unknown -->
          <img v-else
            src="/assets/data_icon/icon_unknown.svg"
            :style="{width: iconWidth, height: iconHeight}"
          >
        </div>
        <!-- RPA -->
        <img v-else-if="item.fileType_selectedFile.category === 'rpa'"
          src="/assets/data_icon/icon_rpa2.svg"
          :style="{width: iconWidth, height: iconHeight}"
        >
        <!-- Re:D -->
        <img v-else
          src="/assets/data_icon/icon_recolumn2.svg"
          :style="{width: iconWidth, height: iconHeight}"
        >
      </div>
      <!-- Re:D -->
      <img v-else
        src="/assets/data_icon/icon_recolumn2.svg"
        :style="{width: iconWidth, height: iconHeight}"
      >
    </div>

    <!-- 즐겨찾기 표시 -->
    <img v-if="showFavorite && favorite"
      src="/assets/favorite-small.svg"
      style="position: absolute; right: 1px; bottom: 1px"
      :style="{width: `calc(${iconWidth}/2)`, height: `calc(${iconHeight}/2)`}"
    >
    <!-- 연결 표시 -->
    <img v-if="isConnected"
      src="/assets/process_icon/connected.svg"
      style="position: absolute; right: -5px; bottom: -5px"
      :style="{width: `18px`, height: `18px`}"
    >
  </div>
</template>

<script>
export default {
  name: "ProcessIcon",

  props: {
    item: {
      type: Object,
      default: () => {}
    },
    iconWidth: {
      type: String,
      default: '26px'
    },
    iconHeight: {
      type: String,
      default: '26px'
    },
    showFavorite: {
      type: Boolean,
      default: true
    },
    favorite: {
      type: Number,
      default: 0
    },
    isConnected: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style scoped>
</style>